import * as React from "react";
const AddPlusIcon = (props) => (
	<svg
		width={24}
		height={24}
		viewBox="0 0 24 24"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<path
			d="M6 12h6m0 0h6m-6 0v6m0-6V6"
			stroke="#647DFF"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
	</svg>
);
export default AddPlusIcon;
